import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=053930c8&scoped=true&"
import script from "./Shop.vue?vue&type=script&lang=ts&"
export * from "./Shop.vue?vue&type=script&lang=ts&"
import style0 from "./Shop.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Shop.vue?vue&type=style&index=1&id=053930c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053930c8",
  null
  
)

export default component.exports